module.exports = __webpack_public_path__ + "media/images/soar/home_page_meet_example-463ebf94797c8a436a06aa85f4bceb1d.png";